export default [
	{ path: '/collections/tops', text: 'TOPS' },
	{ path: '/collections/dresses', text: 'DRESSES' },
	{ path: '/collections/jackets', text: 'JACKETS' },
	{ path: '/collections/skirts', text: 'SKIRTS' },
	{ path: '/collections/trousers', text: 'TROUSES' }
];
